function pad(num){
    var size = 2;
    var s = String(num);
    while(s.length < (size || 2)){
        s = "0" + s;
    }
    return s;
}

class Cookie {
    constructor(contents){
        this.contents = contents;
    }
    generate(){
        $cookies.set(this.getCookieKey(),{});//update new cookie
    }
    //generate key
    getCookieKey(){
        return  `${this.contents.lectureCode}-${this.contents.chapterId}`;
    }
    //generate quizMask key
    getQuizMaskKey(){
        return `quizMask-${this.contents.slideNumber}`; 
    }
    isCookieExist(){
        return $cookies.isKey(this.getCookieKey()); 
    }

    //Quiz mask get
    getQuizMask(){
        let currentCookie = $cookies.get(this.getCookieKey());//fetch cookie
        return currentCookie[this.getQuizMaskKey()];//return associated value
    }
    //Quiz mask set
    setQuizMask(flag){
        let currentCookie = $cookies.get(this.getCookieKey());//fetch cookie
        if(currentCookie){
            currentCookie[this.getQuizMaskKey()] = flag;//update old 
            $cookies.set(this.getCookieKey(),currentCookie);//update new cookie
        }
    }
}

export {pad,Cookie}
